import { Eye, EyeOff } from "lucide-react";

interface AuthPasswordToggleProps {
  isVisible: boolean;
  onToggle: () => void;
}

function AuthPasswordToggle({
  isVisible,
  onToggle,
}: AuthPasswordToggleProps) {
  return (
    <span
      className="lmn-auth-password-toggle"
      onClick={onToggle}
      role="button"
      tabIndex={0}
      aria-label={isVisible ? "Hide password" : "Show password"}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onToggle();
        }
      }}
    >
      {isVisible ? <EyeOff size={16} /> : <Eye size={16} />}
      <span>{isVisible ? "Hide" : "Show"}</span>
    </span>
  );
}

export default AuthPasswordToggle;
